// Exports
export default {
	"spaceBottom": "spaceBottom_Ofn-5"
};
